import { render } from "./OfflineMessage.vue?vue&type=template&id=a51ab1aa"
import script from "./OfflineMessage.vue?vue&type=script&lang=js"
export * from "./OfflineMessage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\TEMP\\Website_Corneel\\luisterlive\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__